<template>
    <div class="rate" v-if="mode==='rate'">
        <div
            class="star-row"
            @touchstart.prevent="touchstart"
            @touchmove.prevent="touchmove"
            @touchend.prevent="touchend"
        >
            <div class="each-star" v-for="(item, index) in 5" :key="index" :style="imgSrc(index)">
                <span class="left-side" :data-index="index"></span>
                <span class="right-side" :data-index="index"></span>
            </div>
        </div>
    </div>
    <div :class="[shape]" v-else>
        <span
            :key="index"
            v-for="(itemClass,index) in itemClasses"
            :class="itemClass"
            class="each-item"
        ></span>
    </div>
</template>
<script>
const LENGTH = 5;
const CLS_ON = "on";
const CLS_HALF = "half";
const CLS_OFF = "off";
//touch事件需要的参数
const WIN_WIDTH = window.innerWidth;
const STAR_WIDTH = WIN_WIDTH * 0.62933333;
const START_POS = WIN_WIDTH * 0.18533333;
const END_POS = WIN_WIDTH * 0.81466666;
export default {
    props: {
        score: {
            type: [String, Number]
        },
        shape: {
            default: "star",
            type: String
        },
        mode: {
            default: "",
            type: String
        }
    },
    data() {
        return {
            calcWidth: "100%",
            curIndex: 4,
            curSide: "right",
            star: "",
            starHalf: "",
            starGrey: ""
        };
    },
    computed: {
        itemClasses() {
            let result = [];
            let score = Math.floor(Number(this.score) * 2) / 2; //将数值调整为整数及.5的形式，例：4.3 => 4；4.6 => 4.5
            let hasDecimal = score % 1 !== 0;
            let integer = Math.floor(score);
            for (let i = 0; i < integer; i++) {
                result.push(CLS_ON);
            }
            if (hasDecimal) {
                result.push(CLS_HALF);
            }
            while (result.length < LENGTH) {
                result.push(CLS_OFF);
            }
            return result;
        }
    },
    mounted() {
        this.star = API.ossUrl + "common/star.svg";
        this.starHalf = API.ossUrl + "common/star-half.svg";
        this.starGrey = API.ossUrl + "common/star-grey.svg";
    },
    methods: {
        imgSrc(index) {
            if (index < this.curIndex) {
                return { backgroundImage: `url(${this.star})` };
            } else if (index == this.curIndex) {
                return {
                    backgroundImage: `url(${
                        this.curSide === "left" ? this.starHalf : this.star
                    })`
                };
            } else {
                return { backgroundImage: `url(${this.starGrey})` };
            }
        },
        touchstart(e) {
            let dom = e.target;
            if (dom.tagName === "SPAN") {
                if (dom.classList.contains("left-side")) {
                    this.$emit("rate:change", Number(dom.dataset.index) + 0.5);
                    this.curSide = "left";
                } else {
                    this.$emit("rate:change", Number(dom.dataset.index) + 1);
                    this.curSide = "right";
                }
                this.curIndex = dom.dataset.index;
            }
        },
        touchmove(e) {},
        touchend(e) {}
    }
};
</script>
<style lang="scss" scoped>
.rate {
    width: 6.293333rem;
    .star-row {
        height: 0.76rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .each-star {
            width: 0.76rem;
            height: 0.76rem;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: contain;
            display: flex;
            .left-side,
            .right-side {
                width: 50%;
                height: 100%;
                display: block;
            }
        }
    }
    .text-row {
        width: 98%;
        margin: 0.266667rem auto 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            color: $grey4;
            font-size: 12px;
        }
    }
}
.star {
    font-size: 0px;
    display: flex;
    .each-item {
        width: 0.373333rem;
        height: 0.373333rem;
        margin-right: 0.066667rem;
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        &:last-child {
            margin-right: 0;
        }
        &.on {
            background-image: url("https://oss.tuoxingwang.com/vaporetto-assets/common/star.svg");
        }
        &.half {
            background-image: url("https://oss.tuoxingwang.com/vaporetto-assets/common/star-half.svg");
        }
        &.off {
            background-image: url("https://oss.tuoxingwang.com/vaporetto-assets/common/star-grey.svg");
        }
    }
}
.laud {
    font-size: 0px;
    display: flex;
    .each-item {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.066667rem;
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        &:last-child {
            margin-right: 0;
        }
        &.on {
            background-image: url("https://oss.tuoxingwang.com/vaporetto-assets/food/png/zan-active.png");
        }
        &.off {
            background-image: url("https://oss.tuoxingwang.com/vaporetto-assets/food/png/zan.png");
        }
    }
}
</style>